

















    import { Swipe, SwipeItem, Image } from 'vant';
    import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
    import { ErrorCode, ErrorInfo, RequestState } from "@/network/http";
    import { BannerInfo } from "@/data/local/banner";

    Vue.use(Swipe);
    Vue.use(SwipeItem);
    Vue.use(Image);

    const KEY_BANNER_LIST = "bannerList";

    @Component({})
    export default class MainBanner extends Vue {

        bannerList: BannerInfo[] = [];

        created() {
            
        }

        mounted() {
            let banners = localStorage.getItem(KEY_BANNER_LIST);
  
            if (banners) {
                this.bannerList = JSON.parse(banners);
            }

            this.fetchBanner();
        }

        fetchBanner() {
/*
            this.bannerList = [
                {
                    id: 1,
                    imgUrl: "http://res.bchun.com/wp-content/uploads/2020/03/yq-banner1.jpg",
                    title: "众志成城，战胜疫情",
                    url:"https://wp.m.163.com/163/page/news/virus_report/index.html?_nw_=0"
                },{
                    id: 2,
                    imgUrl: "http://res.bchun.com/wp-content/uploads/2020/03/qiming-banner.jpg",
                    title: "百纯起名",
                    url:"http://res.bchun.com/archives/121"
                },
            ];
            */
            let lThis:any = this;
            //获取banner
            lThis.$http.getBannerList(null, (errorInfo: ErrorInfo, data: BannerInfo[]) => {
                if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                    return;
                }

                localStorage.setItem(KEY_BANNER_LIST, JSON.stringify(data));
                this.bannerList = data;
            });
            
        }

        onClickBanner(item: BannerInfo): void {
            window.location.href = item.url;
        }
    }
